/* Best MOMents – Landingpage Muttertagskaffee. Texte stehen im HTML (Weglot), das Skript schreibt nur Zahlen und blendet vorbereitete Texte ein und aus. */
(function () {
  'use strict';
  var root = document.getElementById('bmo');
  if (!root) return;

  function $(s, c) { return (c || root).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); }
  function tb(k) { var el = root.querySelector('[data-tb="' + k + '"]'); return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }
  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); return true; } catch (e) { return false; } }
  function num(s) { return parseFloat(String(s).replace(',', '.')); }
  function round5(n) { return Math.round(n / 5) * 5; }
  function mmss(sec) { sec = Math.max(0, Math.floor(sec)); return Math.floor(sec / 60) + ':' + ('0' + (sec % 60)).slice(-2); }
  function setN(scope, key, val) { $$('[data-n="' + key + '"]', scope).forEach(function (el) { el.textContent = val; }); }
  function check(group, btn, attr) { $$('[' + attr + ']', group).forEach(function (b) { b.setAttribute('aria-checked', b === btn ? 'true' : 'false'); }); }
  var pageUrl = (root.getAttribute('data-page-url') || location.href.split('#')[0]).split('?')[0];
  var locale = root.getAttribute('data-locale') || 'de';
  var currency = root.getAttribute('data-currency') || 'EUR';
  function money(cents) {
    try { return new Intl.NumberFormat(locale.length === 2 ? locale + '-DE' : locale, { style: 'currency', currency: currency }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' ' + currency; }
  }
  function share(title, text, url) {
    if (navigator.share) { navigator.share({ title: title, text: text, url: url }).catch(function () {}); return; }
    window.open('https://wa.me/?text=' + encodeURIComponent(text + ' ' + url), '_blank', 'noopener');
  }

  /* ---------- 1. Polaroids umdrehen ---------- */
  $$('.bmo-pol-in').forEach(function (b) {
    b.addEventListener('click', function () { b.setAttribute('aria-pressed', b.getAttribute('aria-pressed') === 'true' ? 'false' : 'true'); });
  });

  /* ---------- 2. Etikett: Mama-Sprache / Kaffee-Sprache ---------- */
  var cards = $('.bmo-cards');
  $$('.bmo-switch [data-lang]').forEach(function (b, i, all) {
    b.addEventListener('click', function () {
      all.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      if (cards) cards.setAttribute('data-mode', b.getAttribute('data-lang'));
    });
  });

  /* ---------- 3. Mama-Check ---------- */
  var sc = { mama: 0, sci: 0, you: 0, done: 0 };
  var qs = $$('.bmo-q');
  function paintScore() { $$('[data-score]').forEach(function (el) { el.textContent = sc[el.getAttribute('data-score')]; }); }
  qs.forEach(function (q) {
    $$('[data-guess]', q).forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (q.classList.contains('is-done')) return;
        var mamaRight = q.getAttribute('data-truth') !== 'sci';
        var right = (btn.getAttribute('data-guess') === 'mama') === mamaRight;
        q.classList.add('is-done', right ? 'is-right' : 'is-wrong');
        btn.classList.add('is-picked');
        if (mamaRight) sc.mama++; else sc.sci++;
        if (right) sc.you++;
        sc.done++;
        var res = $('.bmo-q-res', q);
        if (res) {
          var badge = document.createElement('p');
          badge.className = 'bmo-q-you';
          badge.textContent = tb(right ? 'you-right' : 'you-wrong');
          res.insertBefore(badge, res.firstChild);
          res.hidden = false;
        }
        paintScore();
        if (sc.done === qs.length) { var end = $('.bmo-q-end'); if (end) end.hidden = false; }
      });
    });
  });
  paintScore();
  $$('[data-share="check"]').forEach(function (b) {
    b.addEventListener('click', function () { share(tb('share-title'), tb('share-check'), pageUrl + '#bmo-check'); });
  });

  /* ---------- 4. Rezept ---------- */
  var rs = $('#bmo-rezept');
  if (rs) (function () {
    var d = rs.dataset;
    var R = {
      espDose: num(d.espDose) || 19, espOut: num(d.espOut) || 40, espTime: d.espTime || '30–35',
      filDose: num(d.filDose) || 15, filWater: num(d.filWater) || 250, filTime: d.filTime || '2:30–3:30'
    };
    var raw = d.recipe || '';
    var g = '\\s*g(?:r|ramm)?\\.?\\s*';
    var m = raw.match(new RegExp('(\\d+(?:[.,]\\d+)?)' + g + 'Kaffee\\s*(?:für|fuer|auf|→|->)\\s*(\\d+(?:[.,]\\d+)?)' + g + 'Espresso', 'i'));
    if (m && num(m[1]) > 5 && num(m[2]) > num(m[1])) { R.espDose = num(m[1]); R.espOut = num(m[2]); }
    m = raw.match(/(\d+)\s*(?:[–-]\s*(\d+)\s*)?Sek/i);
    if (m) R.espTime = m[2] ? m[1] + '–' + m[2] : '≈ ' + m[1];
    m = raw.match(new RegExp('(\\d+(?:[.,]\\d+)?)' + g + 'Kaffee\\s*(?:auf|für|fuer)\\s*(\\d+(?:[.,]\\d+)?)' + g + 'Wasser', 'i'));
    if (m && num(m[2]) > num(m[1]) * 8) { R.filDose = num(m[1]); R.filWater = num(m[2]); }
    m = raw.match(/(\d+(?:[.,]\d+)?)\s*(?:bis|–|-)\s*(\d+(?:[.,]\d+)?)\s*Min/i);
    if (m) R.filTime = mmss(num(m[1]) * 60) + '–' + mmss(num(m[2]) * 60);

    var gpl = R.filDose / R.filWater * 1000;
    var espRatio = R.espOut / R.espDose;
    var LIM = { handfilter: [1, 3], chemex: [1, 4], frenchpress: [1, 4], maschine: [1, 5], siebtraeger: [1, 4] };
    var GROUP = { handfilter: 'filter', chemex: 'filter', maschine: 'filter', frenchpress: 'press', siebtraeger: 'esp', bialetti: 'moka', vollautomat: 'auto' };
    var TIMER = { handfilter: 1, chemex: 1, frenchpress: 1 };
    var FACT = { soft: 0.92, normal: 1, strong: 1.1 };
    var ESPF = { soft: 1.2, normal: 1, strong: 0.85 };
    var st = { m: 'handfilter', c: 2, s: 'normal' };

    setN(root, 'bags-cups', Math.floor(250 / R.filDose));
    setN(root, 'bags-shots', Math.floor(250 / R.espDose));

    // gespeichertes Rezept oder Link-Parameter
    var loadedFrom = null;
    try {
      var q = new URLSearchParams(location.search);
      if (q.get('bm') && GROUP[q.get('bm')]) { st.m = q.get('bm'); st.c = parseInt(q.get('bc'), 10) || st.c; st.s = FACT[q.get('bs')] ? q.get('bs') : st.s; loadedFrom = 'link'; }
    } catch (e) {}
    if (!loadedFrom) {
      var saved = lsGet('bmo-recipe');
      if (saved) { try { var o = JSON.parse(saved); if (GROUP[o.m]) { st.m = o.m; st.c = o.c || st.c; st.s = FACT[o.s] ? o.s : st.s; loadedFrom = 'saved'; } } catch (e) {} }
    }

    var cupsOut = $('[data-cups-out]', rs), cupsHint = $('[data-cups-hint]', rs);
    var timerBox = $('[data-timer-box]', rs), clock = $('[data-clock]', rs), timerBtn = $('[data-timer]', rs);
    var methodName = $('[data-method-name]', rs);

    function clampCups() {
      var l = LIM[st.m];
      if (!l) return;
      st.c = Math.min(l[1], Math.max(l[0], st.c));
    }
    function render() {
      clampCups();
      var grp = GROUP[st.m];
      $$('[data-method]', rs).forEach(function (b) { b.setAttribute('aria-checked', b.getAttribute('data-method') === st.m ? 'true' : 'false'); });
      $$('[data-strength]', rs).forEach(function (b) { b.setAttribute('aria-checked', b.getAttribute('data-strength') === st.s ? 'true' : 'false'); });
      $$('[data-panel]', rs).forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== st.m; });
      var mb = $('[data-method="' + st.m + '"] span', rs);
      if (methodName && mb) methodName.textContent = mb.textContent;
      var hasCups = !!LIM[st.m];
      $('[data-cups-field]', rs).hidden = !hasCups;
      $('[data-strength-field]', rs).hidden = !hasCups;
      $$('[data-cups-label]', rs).forEach(function (el) { el.hidden = el.getAttribute('data-cups-label') !== (grp === 'esp' ? 'shot' : 'cup'); });
      if (cupsOut) cupsOut.textContent = st.c;
      if (cupsHint) { var h = tb('cups-hint-' + st.c); cupsHint.textContent = grp === 'esp' ? '' : h; }
      var panel = $('[data-panel="' + st.m + '"]', rs);
      if (grp === 'filter' || grp === 'press') {
        var water = st.c * R.filWater;
        var coffee = Math.round(water * gpl * FACT[st.s] / 1000);
        setN(panel, 'coffee', coffee); setN(panel, 'water', water);
        setN(panel, 'bloom', round5(coffee * 2)); setN(panel, 'p60', round5(water * 0.6)); setN(panel, 'p50', round5(water * 0.5));
        setN(panel, 'filtime', R.filTime);
      } else if (grp === 'esp') {
        var out = Math.round(R.espDose * espRatio * ESPF[st.s]);
        setN(panel, 'espdose', R.espDose); setN(panel, 'espout', out); setN(panel, 'esptime', R.espTime);
        setN(panel, 'espdose-total', Math.round(R.espDose * st.c));
        $$('[data-n-wrap="shots"]', panel).forEach(function (el) { el.hidden = st.c < 2; });
      }
      if (timerBox) timerBox.hidden = !TIMER[st.m];
      stopTimer();
      showTip(null);
    }

    // Methode, Becher, Stärke
    $$('[data-method]', rs).forEach(function (b) { b.addEventListener('click', function () { st.m = b.getAttribute('data-method'); render(); }); });
    $$('[data-cups]', rs).forEach(function (b) { b.addEventListener('click', function () { st.c += parseInt(b.getAttribute('data-cups'), 10); render(); }); });
    $$('[data-strength]', rs).forEach(function (b) { b.addEventListener('click', function () { st.s = b.getAttribute('data-strength'); render(); }); });
    $$('[data-pick]').forEach(function (a) { a.addEventListener('click', function () { st.m = a.getAttribute('data-pick'); render(); }); });

    // Timer
    var tStart = 0, tInt = null, lastIdx = -1, wake = null;
    function stopTimer() {
      if (tInt) { clearInterval(tInt); tInt = null; }
      if (wake && wake.release) { wake.release().catch(function () {}); wake = null; }
      lastIdx = -1;
      if (clock) clock.textContent = '0:00';
      $$('.bmo-steps li', rs).forEach(function (li) { li.classList.remove('is-now', 'is-past'); });
      $$('[data-timer-label]', rs).forEach(function (el) { el.hidden = el.getAttribute('data-timer-label') !== 'start'; });
    }
    function tick() {
      var sec = (Date.now() - tStart) / 1000;
      clock.textContent = mmss(sec);
      var steps = $$('[data-panel="' + st.m + '"] li[data-at]', rs), idx = -1;
      steps.forEach(function (li, i) { if (sec >= parseFloat(li.getAttribute('data-at'))) idx = i; });
      if (idx !== lastIdx) {
        steps.forEach(function (li, i) { li.classList.toggle('is-now', i === idx); li.classList.toggle('is-past', i < idx); });
        if (lastIdx !== -1 && navigator.vibrate) { try { navigator.vibrate(120); } catch (e) {} }
        lastIdx = idx;
      }
    }
    if (timerBtn) timerBtn.addEventListener('click', function () {
      if (tInt) { stopTimer(); return; }
      tStart = Date.now(); tick(); tInt = setInterval(tick, 250);
      $$('[data-timer-label]', rs).forEach(function (el) { el.hidden = el.getAttribute('data-timer-label') !== 'stop'; });
      if (navigator.wakeLock && navigator.wakeLock.request) { navigator.wakeLock.request('screen').then(function (w) { wake = w; }).catch(function () {}); }
    });

    // Wie war's?
    function showTip(fb) {
      $$('[data-fb]', rs).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-fb') === fb ? 'true' : 'false'); });
      $$('[data-tip]', rs).forEach(function (p) { p.hidden = !fb || p.getAttribute('data-tip') !== GROUP[st.m] + '-' + fb; });
    }
    $$('[data-fb]', rs).forEach(function (b) { b.addEventListener('click', function () { showTip(b.getAttribute('data-fb')); }); });

    // Merken, Link, Teilen
    function msg(k) { $$('[data-save-msg]', rs).forEach(function (p) { p.hidden = p.getAttribute('data-save-msg') !== k; }); }
    function recipeUrl() { return pageUrl + '?bm=' + st.m + '&bc=' + st.c + '&bs=' + st.s + '#bmo-rezept'; }
    var saveBtn = $('[data-save]', rs);
    if (saveBtn) saveBtn.addEventListener('click', function () { if (lsSet('bmo-recipe', JSON.stringify(st))) msg('saved'); });
    var copyBtn = $('[data-copy-link]', rs);
    if (copyBtn) copyBtn.addEventListener('click', function () {
      var u = recipeUrl();
      if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(u).then(function () { msg('copied'); }, function () { window.prompt('', u); }); }
      else { window.prompt('', u); }
    });
    var shareBtn = $('[data-share="recipe"]', rs);
    if (shareBtn) shareBtn.addEventListener('click', function () {
      var grp = GROUP[st.m], key = grp === 'esp' ? 'share-recipe-esp' : (grp === 'filter' || grp === 'press') ? 'share-recipe-filter' : 'share-recipe-other';
      var tpl = root.querySelector('[data-tb="' + key + '"]');
      var panel = $('[data-panel="' + st.m + '"]', rs);
      var vals = {
        m: methodName ? methodName.textContent : st.m,
        c: grp === 'esp' ? ($('[data-n="espdose"]', panel) || {}).textContent : ($('[data-n="coffee"]', panel) || {}).textContent,
        w: grp === 'esp' ? ($('[data-n="espout"]', panel) || {}).textContent : ($('[data-n="water"]', panel) || {}).textContent
      };
      var text = '';
      if (tpl) {
        var cl = tpl.cloneNode(true);
        $$('[data-x]', cl).forEach(function (x) { x.textContent = vals[x.getAttribute('data-x')] || ''; });
        text = cl.textContent.replace(/\s+/g, ' ').trim();
      }
      share(tb('share-title'), text, recipeUrl());
    });

    render();
    if (loadedFrom === 'saved') msg('loaded');
  })();

  /* ---------- 5. Polaroid-Generator ---------- */
  var cv = $('[data-gen-canvas]');
  if (cv && cv.getContext) (function () {
    var ctx = cv.getContext('2d');
    var W = cv.width, H = cv.height;
    var wallUrl = (getComputedStyle(root).getPropertyValue('--bmo-wall') || '').match(/url\(["']?([^"')]+)["']?\)/);
    var wall = null, photo = null, pin = '#E76293';
    var input = $('[data-gen-text]'), saveB = $('[data-gen-save]'), shareB = $('[data-gen-share]');
    var bodyFont = (getComputedStyle(root).fontFamily || 'sans-serif');
    var queued = false;
    function load(src, cb) {
      var im = new Image();
      if (!/^blob:|^data:/.test(src)) im.crossOrigin = 'anonymous';
      im.onload = function () { cb(im); };
      im.onerror = function () { cb(null); };
      im.src = src;
    }
    function cover(im, x, y, w, h) {
      var r = Math.max(w / im.naturalWidth, h / im.naturalHeight);
      var sw = w / r, sh = h / r;
      ctx.drawImage(im, (im.naturalWidth - sw) / 2, (im.naturalHeight - sh) / 2, sw, sh, x, y, w, h);
    }
    function lines(text, maxW) {
      var words = text.split(/\s+/), out = [], cur = '';
      words.forEach(function (w) { var t = cur ? cur + ' ' + w : w; if (ctx.measureText(t).width > maxW && cur) { out.push(cur); cur = w; } else cur = t; });
      if (cur) out.push(cur);
      return out;
    }
    function draw() {
      queued = false;
      ctx.save();
      ctx.clearRect(0, 0, W, H);
      if (wall) cover(wall, 0, 0, W, H);
      else { var gr = ctx.createLinearGradient(0, 0, 0, H); gr.addColorStop(0, '#F0615A'); gr.addColorStop(.55, '#F56750'); gr.addColorStop(1, '#FD92AE'); ctx.fillStyle = gr; ctx.fillRect(0, 0, W, H); }
      var fw = 820, inset = 40, ph = 740, fh = inset + ph + 210, fx = (W - fw) / 2, fy = 150;
      ctx.translate(W / 2, fy + fh / 2); ctx.rotate(-2.5 * Math.PI / 180); ctx.translate(-W / 2, -(fy + fh / 2));
      ctx.shadowColor = 'rgba(80,16,16,.35)'; ctx.shadowBlur = 44; ctx.shadowOffsetY = 20;
      ctx.fillStyle = '#FFFDF9'; ctx.fillRect(fx, fy, fw, fh);
      ctx.shadowColor = 'transparent';
      ctx.fillStyle = '#E9D7CF'; ctx.fillRect(fx + inset, fy + inset, fw - 2 * inset, ph);
      if (photo) { ctx.save(); ctx.beginPath(); ctx.rect(fx + inset, fy + inset, fw - 2 * inset, ph); ctx.clip(); cover(photo, fx + inset, fy + inset, fw - 2 * inset, ph); ctx.restore(); }
      var txt = (input && input.value.trim()) || tb('gen-default');
      var maxW = fw - 2 * inset - 20, size = 80, ls;
      function setF(s) { ctx.font = '700 ' + s + 'px "BMO Hand", "Caveat", cursive'; }
      // erst einzeilig versuchen, dann zweizeilig
      setF(size);
      while (ctx.measureText(txt).width > maxW && size > 56) { size -= 2; setF(size); }
      if (ctx.measureText(txt).width <= maxW) ls = [txt];
      else {
        size = 64;
        do { setF(size); ls = lines(txt, maxW); size -= 2; } while ((ls.length > 2 || ls.some(function (l) { return ctx.measureText(l).width > maxW; })) && size > 34);
        size += 2;
      }
      ctx.fillStyle = '#1E1A19'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      var capTop = fy + inset + ph + 8, capH = fh - inset - ph - 52;
      var lh = size * 1.02, nl = Math.min(ls.length, 2);
      ls.slice(0, 2).forEach(function (l, i) { ctx.fillText(l, W / 2, capTop + capH / 2 + (i - (nl - 1) / 2) * lh); });
      ctx.font = '600 21px ' + bodyFont; ctx.fillStyle = '#9B8F8B'; ctx.textAlign = 'right'; ctx.textBaseline = 'alphabetic';
      ctx.fillText('Best MOMents · 19grams', fx + fw - inset, fy + fh - 16);
      // Pin
      var px = W / 2, py = fy + 6;
      ctx.shadowColor = 'rgba(60,10,10,.35)'; ctx.shadowBlur = 10; ctx.shadowOffsetX = 5; ctx.shadowOffsetY = 9;
      ctx.beginPath(); ctx.arc(px, py, 30, 0, Math.PI * 2); ctx.fillStyle = pin; ctx.fill();
      ctx.shadowColor = 'transparent';
      ctx.beginPath(); ctx.arc(px - 10, py - 10, 8, 0, Math.PI * 2); ctx.fillStyle = 'rgba(255,255,255,.65)'; ctx.fill();
      ctx.restore();
    }
    function queue() { if (!queued) { queued = true; (window.requestAnimationFrame || setTimeout)(draw); } }
    if (wallUrl) load(wallUrl[1], function (im) { wall = im; queue(); });
    var first = $('[data-gen-src][aria-checked="true"]') || $('[data-gen-src]');
    if (first) load(first.getAttribute('data-gen-src'), function (im) { photo = im; queue(); });
    $$('[data-gen-src]').forEach(function (b) {
      b.addEventListener('click', function () { check(b.parentNode, b, 'data-gen-src'); load(b.getAttribute('data-gen-src'), function (im) { if (im) { photo = im; queue(); } }); });
    });
    var file = $('[data-gen-file]');
    if (file) file.addEventListener('change', function () {
      var f = file.files && file.files[0];
      if (!f) return;
      $$('[data-gen-src]').forEach(function (b) { b.setAttribute('aria-checked', 'false'); });
      load(URL.createObjectURL(f), function (im) { if (im) { photo = im; queue(); } });
    });
    if (input) input.addEventListener('input', queue);
    $$('[data-gen-sugg]').forEach(function (b) { b.addEventListener('click', function () { if (input) { input.value = b.textContent.trim(); queue(); } }); });
    $$('[data-gen-pin]').forEach(function (b) { b.addEventListener('click', function () { check(b.parentNode, b, 'data-gen-pin'); pin = b.getAttribute('data-gen-pin'); queue(); }); });
    function blob(cb) { try { cv.toBlob(function (b) { cb(b); }, 'image/png'); } catch (e) { cb(null); } }
    var fname = tb('gen-file') || 'best-moment.png';
    if (saveB) saveB.addEventListener('click', function () {
      blob(function (b) {
        if (!b) return;
        var a = document.createElement('a'); a.href = URL.createObjectURL(b); a.download = fname;
        document.body.appendChild(a); a.click(); setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 1500);
      });
    });
    try {
      if (shareB && navigator.canShare && window.File && navigator.canShare({ files: [new File([new Blob(['x'], { type: 'image/png' })], fname, { type: 'image/png' })] })) {
        shareB.hidden = false;
        shareB.addEventListener('click', function () {
          blob(function (b) { if (b) navigator.share({ files: [new File([b], fname, { type: 'image/png' })], title: tb('share-title') }).catch(function () {}); });
        });
      }
    } catch (e) {}
    var fontsReady = document.fonts && document.fonts.load ? Promise.all([document.fonts.load('700 60px "BMO Hand"'), document.fonts.load('600 22px ' + bodyFont)]) : Promise.resolve();
    fontsReady.then(queue, queue);
    queue();
  })();

  /* ---------- 6. Geschenk-Abo ---------- */
  var giftBox = $('[data-gift]');
  var dataEl = document.getElementById('bmo-data');
  if (giftBox && dataEl) (function () {
    var data; try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var gs = { months: 6, roast: 'Filter' };
    var priceEl = $('[data-gift-price]', giftBox), nEl = $('[data-gift-n]', giftBox), perEl = $('[data-gift-per]', giftBox);
    var addB = $('[data-gift-add]', giftBox), err = $('[data-gift-err]', giftBox), link = $('[data-gift-link]', giftBox);
    function prod() { return (data.gifts || []).filter(function (p) { return p.months === gs.months; })[0]; }
    function sel() { return $('[data-gift-grind="' + gs.roast + '"]', giftBox); }
    function variant() {
      var p = prod(); if (!p) return null;
      var s = sel(), grind = s ? s.value : 'ganze Bohne';
      return p.variants.filter(function (v) { return v.roast === gs.roast && v.grind === grind; })[0] || null;
    }
    function label(k) { $$('[data-gift-label]', giftBox).forEach(function (el) { el.hidden = el.getAttribute('data-gift-label') !== k; }); }
    function paint() {
      $$('[data-gift-months]', giftBox).forEach(function (b) { b.setAttribute('aria-checked', +b.getAttribute('data-gift-months') === gs.months ? 'true' : 'false'); });
      $$('[data-gift-roast]', giftBox).forEach(function (b) { b.setAttribute('aria-checked', b.getAttribute('data-gift-roast') === gs.roast ? 'true' : 'false'); });
      $$('[data-gift-grind]', giftBox).forEach(function (s) { s.hidden = s.getAttribute('data-gift-grind') !== gs.roast; });
      var v = variant(), p = prod();
      if (p && link) link.href = p.url;
      if (!v) { addB.disabled = true; label('na'); return; }
      priceEl.textContent = money(v.price);
      nEl.textContent = gs.months;
      perEl.textContent = money(Math.round(v.price / gs.months));
      addB.disabled = !v.available;
      label(v.available ? 'add' : 'na');
    }
    $$('[data-gift-months]', giftBox).forEach(function (b) { b.addEventListener('click', function () { gs.months = +b.getAttribute('data-gift-months'); paint(); }); });
    $$('[data-gift-roast]', giftBox).forEach(function (b) { b.addEventListener('click', function () { gs.roast = b.getAttribute('data-gift-roast'); paint(); }); });
    $$('[data-gift-grind]', giftBox).forEach(function (s) { s.addEventListener('change', paint); });
    if (addB) addB.addEventListener('click', function () {
      var v = variant(); if (!v || !v.available) return;
      addB.disabled = true; label('busy'); if (err) err.hidden = true;
      var item = { id: v.id, quantity: 1 };
      if (v.plan) item.selling_plan = v.plan;
      fetch((root.getAttribute('data-cart-add') || '/cart/add') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [item] })
      }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function () { location.href = root.getAttribute('data-cart') || '/cart'; })
        .catch(function () { addB.disabled = false; label('add'); if (err) err.hidden = false; });
    });
    paint();
  })();

  /* ---------- 7. Muttertag-Countdown und Kalender ---------- */
  function motherDay(y) { var d = new Date(y, 4, 1), first = 1 + ((7 - d.getDay()) % 7); return new Date(y, 4, first + 7); }
  var today = new Date(); today.setHours(0, 0, 0, 0);
  var md = motherDay(today.getFullYear());
  if (md < today) md = motherDay(today.getFullYear() + 1);
  var left = Math.round((md - today) / 86400000);
  $$('[data-md="day"]').forEach(function (el) { el.textContent = md.getDate() + '.'; });
  $$('[data-md="year"]').forEach(function (el) { el.textContent = md.getFullYear(); });
  $$('[data-md="left"]').forEach(function (el) { el.textContent = left; });
  function ymd(d) { return d.getFullYear() + ('0' + (d.getMonth() + 1)).slice(-2) + ('0' + d.getDate()).slice(-2); }
  function esc(s) { return String(s).replace(/\\/g, '\\\\').replace(/;/g, '\\;').replace(/,/g, '\\,').replace(/\n/g, '\\n'); }
  $$('[data-ics]').forEach(function (b) {
    b.addEventListener('click', function () {
      var end = new Date(md); end.setDate(end.getDate() + 1);
      var now = new Date(), stamp = now.toISOString().replace(/[-:]/g, '').replace(/\.\d+Z$/, 'Z');
      var ics = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//19grams//Best MOMents//DE', 'CALSCALE:GREGORIAN', 'BEGIN:VEVENT',
        'UID:muttertag-' + md.getFullYear() + '@19grims.com', 'DTSTAMP:' + stamp,
        'DTSTART;VALUE=DATE:' + ymd(md), 'DTEND;VALUE=DATE:' + ymd(end),
        'SUMMARY:' + esc(tb('ics-title')), 'DESCRIPTION:' + esc(tb('ics-alarm') + ' ' + pageUrl), 'URL:' + pageUrl,
        'BEGIN:VALARM', 'TRIGGER:-P7D', 'ACTION:DISPLAY', 'DESCRIPTION:' + esc(tb('ics-alarm')), 'END:VALARM',
        'END:VEVENT', 'END:VCALENDAR'].join('\r\n');
      var a = document.createElement('a');
      a.href = URL.createObjectURL(new Blob([ics], { type: 'text/calendar;charset=utf-8' }));
      a.download = 'muttertag-' + md.getFullYear() + '.ics';
      document.body.appendChild(a); a.click(); setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 1500);
    });
  });
})();
